export function isValidGermanZipCode(zipCode: string): boolean {
  return /^\d{5}$/.test(zipCode);
}
